module.exports = __webpack_public_path__ + "img/album07_10.43a95e29.jpg";